














import Vue from 'vue'

import type { HTMLInputEvent } from '@/models/common'

import IconSearch from '@/assets/svg/rounded/search.svg?inline'

interface Methods {
  handleInput: (e: HTMLInputEvent) => void
  handleFocus: (e: HTMLInputEvent) => void
  handleBlur: (e: HTMLInputEvent) => void
  handleClear: () => void
}

interface Props {
  value: string
  placeholder: string
  hasClear: boolean
}

export default Vue.extend<{}, Methods, {}, Props>({
  components: {
    IconSearch,
  },
  props: {
    value: {
      default: () => '',
    },
    placeholder: {
      default: () => undefined,
    },
    hasClear: {
      default: () => false
    }
  },
  methods: {
    handleInput(e: HTMLInputEvent) {
      this.$emit('input', e.target?.value ?? '')
    },
    handleFocus(e: HTMLInputEvent) {
      this.$emit('focus', e)
    },
    handleBlur(e: HTMLInputEvent) {
      this.$emit('blur', e)
    },
    handleClear() {
      this.handleInput({ target: { value: '' } })
    }
  },
})
